var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value === 'Yes')?_c('img',{attrs:{"src":"/tick.jpg"}}):(_vm.value === 'No')?_c('img',{attrs:{"src":"/cross.jpg"}}):_c('span',[_c('img',{attrs:{"src":"/tick.jpg"}}),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.subtext)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }